/*TABLE SCROLLER SUPPORT MIXIN
 * 
 * Adds support for full screen datatables to allow for scrollable tabular data, in areas similar to format of Foster Child List
 * This is does not work globally, but will provide the neccessary support for similar components.
 * 
 * Component Requirements for Implementation:
 *      ADD VISIBILITY DETECTION TO COMPONENT:
 *       v-observe-visibility="VisibilityChanged"
 *       ie: <div class="ChildList" v-observe-visibility="VisibilityChanged">
 *      
        WRAP FILTERS IN:
            <div ref="divtophalf">  {filters go here}  </div>

        ADD ARGUMENT TO VueTable COMPONENT:
            :table-height="CalcTableHeight"
        


        Add v-show="ShowFilters" to form component for table filters

        ADD ICON TO TOGGLE FILTERS
            <span v-b-tooltip.hover title="Hide/Show Filters"><font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" /></span>

        IMPORT ICONS:
            import { faEye } from '@fortawesome/free-solid-svg-icons';
            library.add(faEye);
            import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
            library.add(faEyeSlash);

        ADD MIXIN:
        import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js"; **location will vary**
 */
import { EventBus } from '../services/event-bus.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
library.add(faEye);
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
library.add(faEyeSlash);

export const TableScrollerSupport = {
    created() {
        EventBus.$on('window-resized', this.HandleWindowResize);
    },
    beforeDestroy() {
        EventBus.$off('window-resized');
    },
    mounted() {
        this.IsMounted = true;
        this.HandleWindowResize();
    },
    data: function () {
        return {
            ShowFilters: true,
            Adjuster: 1,
            IsMounted: false,
            WindowHeight: 0
        }
    },
    methods: {
        ToggleShowFilters() {
            this.ShowFilters = !this.ShowFilters;
            let vm = this;
            this.$nextTick(() => {
                vm.Adjuster++;
            });

        },
        HandleWindowResize() {
            this.WindowHeight = window.innerHeight;
        },
        VisibilityChanged(isVisible, entry) {
            if (isVisible) {
                this.Adjuster++;
            }
        },
    },
    computed: {
        CalcTableHeight: function () {
            if (this.IsMounted) {
                let adjuster = this.Adjuster;
                let headerSize = 68;
                let additionalAdjustment = 115
                let filterHeight = this.$refs.divtophalf.clientHeight;
                //console.log(this.$refs.divtophalf);
                //console.log("filterHeight: " + filterHeight);
                //console.log("windowHeight: " + this.WindowHeight);
                return (this.WindowHeight - filterHeight - headerSize - additionalAdjustment) + "px";
            } else {
                return "100px";
            }

        }
    }
}